<div class="container">
	<div class="container-body">
		<div class="row">
			<div class="col-7">
				<strong>{{modelService.getString('project_detail_quote_for')}}</strong>&nbsp;{{projectData.nombre}}
			</div>
			<div class="col-5 project-status">
				<span>{{ modelService.getString('project_builder_status') }}:&nbsp;{{ currentStatus | projectStatusPipe }}</span>
			</div>
		</div>

		<!--div class="row options"><button (click)="getPDF(true)"><i class="fa fa-file-pdf-o fa-2x btn-enviar-pre"></i></button>
		<button (click)="getPDF(false)"><i class="fa fa-file-pdf-o fa-2x"></i></button></div-->

		<div class="row segmentInfoHolder" *ngFor="let perimetro of datosGrid.perimetro; let index = index;">
			<div *ngIf="isGMAPS()" class="segmentInfoTitle col-12">
				<strong>
					{{modelService.getString('project_segment')}}&nbsp;{{index + 1}}&nbsp;(
					{{modelService.getString('builder_lineal_length')}}:{{perimetro.longitudStr}}m.;&nbsp;
					{{modelService.getString('builder_real_length')}}:&nbsp;{{perimetro.presupuesto.unity.mlStr }}m )
				</strong>
			</div>
			<div *ngIf="isSCHEME2()" class="segmentInfoTitle col-12">
				<strong>
					{{modelService.getString('project_segment')}}&nbsp;{{index + 1}}&nbsp;(
					{{modelService.getString('builder_lineal_length')}}:&nbsp;{{perimetro.longitudStr}}m )
				</strong>
			</div>
			<div class="segmentInfoList col-12">
				<table class="col-12 desglose">
					<tr>
						<th class="columnaProductoTitle">
							<strong>{{modelService.getString('project_productCode')}}</strong>
						</th>
						<th class="columnaDescripcionTitle">
							<strong>{{modelService.getString('project_description')}}</strong>
						</th>
						<th class="columnaCantidadTitle">
							<strong>{{modelService.getString('project_quantity')}}</strong>
						</th>
						<th class="columnaPrecioTitle">
							<strong>{{modelService.getString('project_price')}}</strong>
						</th>
						<th class="columnaDescTitle">
							<strong>{{modelService.getString('project_discount')}}</strong>
						</th>
						<th class="columnaTotalTitle">
							<strong>{{modelService.getString('project_totalLine')}}</strong>
						</th>
					</tr>

					<tr>
						<td colspan="6">&nbsp;</td>
					</tr>

					<tr *ngFor="let item of perimetro.grid" class="marginTR_Grid">
						<td class="columnaProducto">{{item.cod_producto}}</td>
						<td class="columnaDescripcion">{{item.descripcion}}</td>
						<td class="columnaCantidad">{{formatMilesStr(item.cantidad)}}</td>
						<td class="columnaPrecio">{{item.precio}}</td>
						<td class="columnaDesc">{{item.descuento}}</td>
						<td class="columnaTotal">{{item.total}}</td>
					</tr>

					<tr>
						<td colspan="6">&nbsp;</td>
					</tr>

					<tr class="marginTR_Grid">
						<td class="columnaDatasEnd" colspan="2">&nbsp;</td>
						<td class="columnaName" colspan="3">
							<strong>{{modelService.getString('project_subtotal')}}</strong>
						</td>
						<td class="columnaData">{{formatoDecimalStr(perimetro.subtotal)}}€</td>
					</tr>

					<!--tr *ngIf="tieneMC" class="marginTR_Grid"><td class="columnaDatasEnd" colspan="2">&nbsp;</td>
				<td class="columnaName" colspan="3"><strong>{{modelService.getString('pdf _descuento')}}{{project Data.mc}}%</strong></td>
				<td class="columnaData">{{perimetro.descuentoStr}}€</td></tr>
			  <tr *ngIf="tieneMC" class="marginTR_Grid"><td class="columnaDatasEnd" colspan="2">&nbsp;</td>
				<td class="columnaName" colspan="3"><strong>{{modelService.getString('pdf _aplicado')}}</strong></td>
				<td class="columnaData">{{perimetro.aplicadoStr}}€</td></tr-->

					<tr class="marginTR_Grid">
						<td class="columnaDatasEnd" colspan="2">&nbsp;</td>
						<td class="columnaName" colspan="3">
							<strong>{{modelService.getString('project_vat')}}{{perimetro.vat}}%</strong>
						</td>
						<td class="columnaData">{{formatoDecimalStr(perimetro.vatTotal)}}€</td>
					</tr>

					<tr class="marginTR_Grid">
						<td class="columnaDatasEnd" colspan="2">&nbsp;</td>
						<td class="columnaName" colspan="3">
							<strong>{{modelService.getString('project_total')}}</strong>
						</td>
						<td class="columnaData">
							<strong>{{formatoDecimalStr(perimetro.total)}}€</strong>
						</td>
					</tr>

				</table>
			</div>

			<div class="row col-12" *ngIf="(perimetro.presupuesto.error == 'verja_error_inclinacion')">
				<h3 class="errorUnevenness">{{modelService.getString('error_unevenness')}}</h3>
			</div>

			<div class="row col-12" *ngIf="perimetro.informacion.comentarios">
				<h3 class="comentario">
					<span>{{modelService.getString('comentario')}} : </span>{{perimetro.informacion.comentarios}}
				</h3>
			</div>
		</div>

		<!-- Botón cacenlar presupuesto. -->
		<div class="row col-12 botonesPresupuesto">
			<button *ngIf="botones.cancelar" id="cancel" type="button" (click)="cancelProject()" class="btn col-3 btn-cancelar-pre">
				<i class="fa fa-ban" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_cancel') }}
			</button>
			<div [class.col-4]="!botones.cancelar" [class.col-1]="botones.cancelar"></div>

			<!-- Botón ir al editor -->
			<button (click)="onClick()" type="button" class="btn col-4 btn-ver-pre">
				<i class="fa fa-eye" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_modify') }}
			</button>

			<div [class.col-4]="!botones.aceptarEnviar" [class.col-1]="botones.aceptarEnviar"></div>

			<!-- Botón Enviar a Revisión. -->
			<button *ngIf="botones.enviar" id="send" type="button" (click)="sendProject()"
				class="btn col-3 btn-enviar-pre">
				<i class="fa fa-share-square-o" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_review') }}
			</button>

			<!-- Botón aceptar el presupuesto. -->
			<button *ngIf="botones.aceptar" id="accept" type="button" (click)="acceptProject()"
				class="btn col-3 btn-aceptar-pre">
				<i class="fa fa-check" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_accept') }}
			</button>
		</div>

		<div class="row col-12 botonesPDF">
			<div class="col-1"></div>

			<button class="btn col-5 btn-pdf-sinMC-pre" type="button" (click)="getPDF(false)">
				<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_PDFnoMC') }}
			</button>

			<button class="btn col-5 btn-pdf-conMC-pre" type="button" (click)="getPDF(true)">
				<i class="fa fa-file-pdf-o" aria-hidden="true"></i>
				{{ modelService.getString('project_detail_PDFyesMC') }}
			</button>

			<div class="col-1"></div>
		</div>

	</div>
	<div class="row main"></div>
</div>

<app-loader #loader *ngIf="loading"></app-loader>